import Input from '../../../../../components/form/Input';
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import CustomButton, {SecondaryButton} from '../../../../../components/CustomButton'
import {
  updateEducation,
  updateExperience
} from '../../../../../redux/slices/doctorSlice'
import PropTypes from "prop-types";

const EditForm = ({ isEducation, data, toggleForm, id, isLoading }) => {
  const Dispatch = useDispatch()
  const [userInput, setUserInput] = useState([])

  useEffect(() => {
    if (isEducation) {
      let education = {
        id: data?.id || '',
        institute: data?.institute || '',
        degree: data?.degree || '',
        joining_date: data?.joining_date || '',
        completion_date: data?.completion_date || '',
      }
      setUserInput(education)
    } else {
      let experience = {
        id: data?.id || '',
        institute: data?.institute || '',
        designation: data?.designation || '',
        joining_date: data?.joining_date || '',
        completion_date: data?.completion_date || '',
      }
      setUserInput(experience)
    }
  }, [data, isEducation])

  function isFormFilled() {
    return (
      (userInput.institute || '').trim().length > 1 &&
      (userInput.joining_date || '').trim().length === 10 &&
      (userInput.completion_date.trim() || '').length === 10 &&
      (isEducation
        ? (userInput.degree || '').trim().length > 1
        : (userInput.designation || '').trim().length > 1) &&
      !isLoading
    )
  }

  const handleInputChange = (e) => {
    const oldInput = { ...userInput }
    const { name, value } = e.target
    oldInput[name.trim()] = value
    setUserInput(oldInput)
  }

  const submitChanges = () => {
    let payload = {
      id: id,
      userChanges: [userInput],
    }
    if (isEducation) {
      Dispatch(updateEducation(payload))
    } else {
      Dispatch(updateExperience(payload))
    }
  }

  const validateDate = () => {
    return userInput.joining_date < userInput.completion_date
  }

  return (
    <div className="flex flex-col border-dashed border-b-4 border-light-blue-500 mt-3 pt-5">
      <div>
        <label htmlFor="insitute">Institute name*</label>
        <Input
          value={userInput.institute || ''}
          name="institute"
          onChange={(e) => handleInputChange(e)}
          placeholder=""
        />{' '}
      </div>{' '}
      <br />
      <div className="flex justify-between">
        <div>
          <label htmlFor="degree">
            {isEducation ? 'Degree*' : 'Designation*'}
          </label>
          <Input
            value={
              isEducation
                ? userInput.degree || ''
                : userInput.designation || ''
            }
            name={isEducation ? 'degree' : 'designation'}
            onChange={(e) => handleInputChange(e)}
            placeholder=""
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="joining-data">Joining Date*</label>
          <input
            className="p-3 w-30 h-10 border-b-2 border-black"
            type="date"
            name="joining_date"
            value={userInput?.joining_date || ""}
            onChange={(e) => handleInputChange(e)}
            min="1950-01-01"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="completion-date">Completion Date*</label>
          <input
            className="p-3 w-30 h-10 border-b-2 border-black"
            type="date"
            name="completion_date"
            value={userInput?.completion_date || ""}
            onChange={(e) => handleInputChange(e)}
            min="1950-01-01"
          />
        </div>
      </div>
      <br />
      {!validateDate() && (
        <p className="text-red-500 text-center">
          Joining date must be older than completion date
        </p>
      )}
      <br />
      <div className="flex justify-end">
        <SecondaryButton
          onClick={() => toggleForm(false)}
        >
          Cancel
        </SecondaryButton>
        <div className="w-5"></div>
        <CustomButton
          disabled={!isFormFilled() || !validateDate()} onClick={submitChanges}>
          Save
        </CustomButton>
      </div>
      <br />
    </div>
  )
}

EditForm.propTypes = {
  isEducation: PropTypes.bool.isRequired,
  data:PropTypes.object,
  id: PropTypes.string.isRequired,
  isLoading:PropTypes.bool.isRequired
};

export default EditForm
